<div class="flex flex-col gap-y-8 justify-center">
  <h1 class="marketing-h1">
    <slot name="title" />
  </h1>
  <div class="lg:hidden flex flex-row justify-center max-h-80">
    <slot name="image" />
  </div>
  <div class="text-base md:text-lg text-light-green/60">
    <slot name="subtitle" />
  </div>

  <div class="flex flex-row gap-x-4 justify-start">
    <slot name="cta" />
  </div>
</div>

{#if $$slots.image}
  <div class="hidden lg:block">
    <slot name="image" />
  </div>
{/if}
